import { createVanIconComponent } from "./van"

const Lock = createVanIconComponent("lock")
export default Lock
